/* eslint-disable no-debugger */
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import AppButton from '../../shared/components/app-button/AppButton';
// import AppLink from '../../shared/components/app-link/AppLink';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';

import { doLoginApi, getAppConstants } from '../../api/loginApi';
import {
  setStringInLs,
  setDataInLS,
} from '../../shared/helper-utils/localStorage';
import {
  APP_LOGGEDIN_AGENTID,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import ForgotPassword from './ForgotPassword';
import AppModal from '../../shared/components/app-modal/AppModal';
import {
  APP_CONFIG,
  APP_USER_AUTH,
  APP_USER_PROFILE,
} from '../../saas/AppStorageStaticNames';
import AppLink from '../../shared/components/app-link/AppLink';

function LoginVoyra() {
  // const intl = useIntl();
  const [showForm, setShowForm] = useState('login');
  const [alert, setAlert] = useState(undefined);
  const [validationError, setValidationError] = useState(false);
  const [login, setLogin] = useState({
    agent_userid: '',
    agent_password: '',
    opid: 'AU001',
    usertype: 'reactclient',
    agencycode: '',
    responseformat: 'JSON',
    securetoken: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  //   const formattedMessage = (message) => {
  //     return intl.formatMessage({ id: message });
  //   };

  const getSecureTocken = async () => {
    setIsLoading(true);
    try {
      // eslint-disable-next-line no-undef
      const response = await FingerprintJS.load();
      const result = await response.get();
      const token = result.visitorId;
      setLogin((prev) => ({ ...prev, securetoken: token }));
    } catch (error) {
      setLogin((prev) => ({ ...prev, securetoken: '' }));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getSecureTocken();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setLogin((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (login.agent_userid === '' || login.agent_password === '') {
      setValidationError(true);
    } else {
      setValidationError(false);
      setIsLoading(true);
      const loginResponse = await doLoginApi(login);
      setIsLoading(false);
      if (loginResponse?.ApiStatus?.StatusCode !== 200) {
        setAlert({
          variant: 'error',
          title: 'Login Failed',
          description: loginResponse?.ApiStatus?.Message,
        });
      } else {
        const { Result } = loginResponse.ApiStatus;
        if (Result === 'OTPSENT') {
          setShowOtpModal(true);
        } else {
          const profileInfo = loginResponse.ApiStatus.Result.split('@@@');
          const profile = {
            agentId: profileInfo[0],
            profileId: profileInfo[1],
            title: profileInfo[2],
            firstName: profileInfo[3],
            lastName: profileInfo[4],
            systemRoleId: profileInfo[5],
            companyName: profileInfo[6],
          };
          setDataInLS(APP_USER_PROFILE, profile);
          setStringInLs(APP_LOGGEDIN_AGENTID, profile.agentId);
          setStringInLs(
            APP_USER_AUTH,
            loginResponse.ApiStatus.TransactionStatus,
          );
          setIsLoading(true);
          const response = await getAppConstants();
          if (response?.Root?.Status === 'OK') {
            const { ConfigSetting } = response.Root.Result.ConfigSettings;
            const appConfig = Array.isArray(ConfigSetting)
              ? ConfigSetting
              : ConfigSetting;
            setDataInLS(APP_CONFIG, appConfig);
          }
          setIsLoading(false);
          window.location.href = NAVIGATION_ROUTES.LANDING;
        }
      }
    }
  };

  const handleShowForm = (formType) => {
    setShowForm(formType);
  };

  return (
    <>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      {showForm === 'login' ? (
        <div className="login-form-card">
          <form className="login-form d-flex flex-column justify-content-between flex-1">
            <div className="d-flex flex-column">
              {/* Agency ID — label above input */}
              <div className="field-group">
                <span className="field-label">Agency ID</span>
                <AppTextInput
                  name="agent_userid"
                  id="agent_userid"
                  placeholderText="VG-XXXXX"
                  className="login-form--app-input userId"
                  errorText={
                    validationError ? (
                      <FormattedMessage id="user_id_validation" />
                    ) : (
                      ''
                    )
                  }
                  onChange={handleChange}
                  value={login.agent_userid}
                />
              </div>

              {/* Password — label above input */}
              <div className="field-group">
                <span className="field-label">Password</span>
                <AppTextInput
                  name="agent_password"
                  id="agent_password"
                  type={showPassword ? 'text' : 'password'}
                  placeholderText="••••••••"
                  className="login-form--app-input password"
                  rightIcon={
                    showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />
                  }
                  onRightIconClick={() => setShowPassword((prev) => !prev)}
                  errorText={
                    validationError ? (
                      <FormattedMessage id="password_validation" />
                    ) : (
                      ''
                    )
                  }
                  onChange={handleChange}
                  value={login.agent_password}
                />
              </div>
            </div>
            <div className="text end pb-2 pl-10">
              <AppLink
                className="fw-500 fs-14 d-inline"
                variant="primary"
                onClick={() => handleShowForm('forgot')}
                linkText={<FormattedMessage id="forgot_password_link" />}
              />
            </div>
            <div className="d-flex flex-column">
              <AppButton
                btnText="Login"
                btnType="submit"
                className="signIn"
                variant="primary"
                onClick={handleSubmit}
              />
            </div>
          </form>
        </div>
      ) : (
        <ForgotPassword
          onShowForm={handleShowForm}
          onLoading={setIsLoading}
          onAlert={setAlert}
        />
      )}
      {showOtpModal && (
        <AppModal
          modalTitle="Enter OTP Received on Email"
          showCloseButton
          onModalClose={() => setShowOtpModal(false)}
        >
          <div>
            <div className="d-flex gap-2">
              <AppTextInput
                onChange={handleChange}
                value={login.otp}
                name="otp"
                placeholderText=""
                label="Otp"
              />
              <AppButton btnText="Done" onClick={handleSubmit} />
            </div>
          </div>
        </AppModal>
      )}
    </>
  );
}

export default LoginVoyra;
